import Vue from 'vue'
import VueRouter from 'vue-router';
import { Store } from 'vuex';
import {setTitleWithApp} from '@/utils/util'
var isWeta365 = window.location.href.indexOf('source=weta365') !== -1;
console.log('---isWeta365',isWeta365)
let titleMap={
    "/vipWechatPay":"魔音工坊",
    "/downloadApp":"魔音工坊",
    "/protocol":"魔音工坊",
    "/privacy":"魔音工坊",
    "/commonList":"魔音工坊",
    "/sdkList":"魔音工坊",
    "/videoProtocol":"魔音工坊",
    "/middlePageOfPay": "魔音工坊",
    "/realPaySuccess": "魔音工坊",
    "/voiceClone": "魔音工坊",
    "/voicePaySuccess": "魔音工坊",
    "/extraList": "提取历史",
    "/fileExtract": "文案提取",
    "/accredit": "授权我的作品账号",
    "/activity": "我的账号",
    "/activityManager": "授权账号管理",
    "/leaderboard": "排行榜",
    "/textGenerate": "文案生成",
    "/textGenerateList": "生成历史",
    "/welfareCenter": "福利中心",
    "/signIn": "每日签到",
    "/exchangeBean": "魔豆兑换",
    "/memberDay": "会员日",
    "/welfareRules": "活动规则",
    "/welfareRecords": "获得/兑换记录",
    "/cutProduction": "剪辑作品",
    "/moyouPic": "达人赛",
    "/realPersonPaySuccess": "魔音工坊",
    "/couponList": "我的优惠券",
}

let weta365TitleMap={
    "/":"奇妙元",
    "/article":"奇妙元"
}
export default function initRouter(router:VueRouter,store: Store<any>){
 let titleMaps = isWeta365?weta365TitleMap:titleMap;
    router.beforeEach((to, from, next) => {
        document.title =titleMaps[to.path] || to?.meta?.title ||to.name || ""
        setTitleWithApp()
         next()
    });
}
